/*
 * Crush Audio - acceptation des conditions de vente avant paiement.
 *
 * Le bouton de paiement du bloc concerne est desactive tant que la case est
 * decochee. Fonctionne aussi bien sur la page panier que dans le tiroir, et
 * survit aux re-rendus du tiroir apres modification du panier.
 */
(function () {
  if (window.__crushTerms) return;
  window.__crushTerms = true;

  function checkoutButtonsFor(box) {
    // Le bouton vit dans .cart__ctas, frere ou oncle de la case.
    var scope = box.closest('.drawer__footer, .cart__footer, cart-drawer, form, body') || document;
    return Array.prototype.slice.call(scope.querySelectorAll('.cart__checkout-button, button[name="checkout"]'));
  }

  // Les blocs de paiement express sont freres de .cart__ctas, pas enfants :
  // on les cherche dans tout le document.
  function expressBlocks() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.cart__dynamic-checkout-buttons, [data-shopify-buttoncontainer], .additional-checkout-buttons')
    );
  }

  function applyOne(box) {
    var accepted = box.checked;

    // Les paiements express contournent le bouton principal : on les neutralise
    // aussi, sinon le consentement ne sert a rien.
    expressBlocks().forEach(function (el) {
      el.classList.toggle('crush-express-locked', !accepted);
      el.setAttribute('aria-hidden', accepted ? 'false' : 'true');
    });

    checkoutButtonsFor(box).forEach(function (btn) {
      if (accepted) {
        // On ne reactive que ce que l'on a soi-meme desactive : un panier vide
        // doit rester bloque.
        if (btn.dataset.crushTermsLocked === 'true') {
          btn.disabled = false;
          delete btn.dataset.crushTermsLocked;
        }
      } else if (!btn.disabled) {
        btn.disabled = true;
        btn.dataset.crushTermsLocked = 'true';
      }
    });
  }

  function applyAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-crush-terms-input]'), applyOne);
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest ? e.target.closest('[data-crush-terms-input]') : null;
    if (box) applyOne(box);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  // Le tiroir est reconstruit a chaque modification du panier.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(applyAll, 0);
    });
  }

  var drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(function () {
      applyAll();
    }).observe(drawer, { childList: true, subtree: true });
  }
})();
